export interface ConditionalVisibilityMessageSelection {
  kind: "hidden" | "reset-exhausted";
  markdown: string;
}

export function selectConditionalVisibilityMessage(options: {
  hiddenMessageEnabled: boolean;
  hiddenMessage: string;
  resetExhausted: boolean;
  resetExhaustedMessage: string;
}): ConditionalVisibilityMessageSelection | null {
  if (options.resetExhausted && options.resetExhaustedMessage.trim()) {
    return {
      kind: "reset-exhausted",
      markdown: options.resetExhaustedMessage,
    };
  }
  if (options.hiddenMessageEnabled && options.hiddenMessage.trim()) {
    return {
      kind: "hidden",
      markdown: options.hiddenMessage,
    };
  }
  return null;
}
